export const GAMES = [
  "League of Legends", "Counter-Strike 2", "Call of Duty", "Fortnite", "EA FC",
];

// Paliers par jeu : on ne propose que ce qui existe réellement dans le jeu choisi.
export const RANKS = {
  "League of Legends": ["Fer", "Bronze", "Argent", "Or", "Platine", "Émeraude", "Diamant", "Maître", "Grand Maître", "Challenger"],
  "Counter-Strike 2": ["Argent", "Nova", "AK", "Aigle", "Suprême", "Global", "Premier 5 000+", "Premier 10 000+", "Premier 15 000+"],
  "Call of Duty": ["Bronze", "Argent", "Or", "Platine", "Diamant", "Cristal", "Iridescent", "Top 250"],
  "Fortnite": ["Bronze", "Argent", "Or", "Platine", "Diamant", "Élite", "Champion", "Unreal"],
  "EA FC": ["Division 10", "Division 8", "Division 6", "Division 4", "Division 2", "Division 1", "Élite"],
};
export const DEFAULT_RANKS = ["Débutant", "Intermédiaire", "Avancé", "Compétitif", "Semi-professionnel"];
export const ranksFor = game => RANKS[game] || DEFAULT_RANKS;

// Ce que le joueur vient chercher. Il n'y a qu'un coach sur la plateforme :
// l'intention « je veux coacher » n'a plus d'objet.
export const INTENTS = [
  { key: "player", icon: "Target", title: "Progresser sur mon jeu", desc: "Corriger mes erreurs et monter de niveau." },
  { key: "coach", icon: "Users", title: "Préparer une compétition", desc: "Règlement, stratégie et routines d'entraînement." },
];

export const GOALS = [
  "Monter d'une division", "Corriger mes erreurs récurrentes", "Travailler mon mental",
  "Préparer une compétition", "Apprendre un nouveau rôle", "Progresser en équipe",
];
